"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function FileUploadInformation(_ref) {
  var otherPersonaIds = _ref.otherPersonaIds;
  var uploadInfo = (0, _reactRedux.useSelector)(function (state) {
    return state.fileUploadMeta;
  });
  var fileName = uploadInfo.fileName,
      dirtyData = uploadInfo.dirtyData,
      duplicatePersonas = uploadInfo.duplicatePersonas,
      personasAdded = uploadInfo.personasAdded,
      emptyData = uploadInfo.emptyData;
  var personasAddedLength = personasAdded.length;
  var emptyDataLength = emptyData.length;
  var dirtyDataLength = dirtyData && dirtyData.length;
  var duplicatePersonasLength = duplicatePersonas && duplicatePersonas.length; // check which personas in the list added belong to the 'other' group so we can show related output

  var includesOtherPersonas = personasAdded.filter(function (persona) {
    return otherPersonaIds.includes(persona);
  }); // logic for icon to display

  var icon = duplicatePersonasLength || dirtyDataLength || personasAddedLength === 0 ? 'warning' : 'check';
  return duplicatePersonasLength > 0 || dirtyDataLength > 0 || personasAddedLength > 0 || fileName ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "file-upload__info-box " + icon
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    className: "csv-handler__info-icon",
    name: icon + " circle",
    size: "large" // color="yellow"
    // color="green"

  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "The uploaded file contains values for ", personasAddedLength, " Persona", personasAddedLength > 1 && 's', includesOtherPersonas.length > 0 && ", including " + includesOtherPersonas.join(', ') + " Other"), !!dirtyDataLength && /*#__PURE__*/_react["default"].createElement("p", null, "Data for ", dirtyDataLength, " other line", dirtyDataLength > 1 ? 's' : '', " has been ignored"), !!duplicatePersonasLength && /*#__PURE__*/_react["default"].createElement("p", null, "Duplicated data was found for ", duplicatePersonasLength, " Persona", duplicatePersonasLength > 1 && 's', " (", duplicatePersonas.join(', '), ")"), !!emptyDataLength && /*#__PURE__*/_react["default"].createElement("p", null, emptyDataLength, " Persona", emptyDataLength > 1 && 's', " listed had a value of zero and", ' ', emptyDataLength > 1 ? 'have' : 'has', " been excluded from the audience profile"), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("b", null, "Uploaded file:"), " ", fileName))) : null;
}

var _default = FileUploadInformation;
exports["default"] = _default;